import { Route, Routes, BrowserRouter } from "react-router-dom";
import "./App.css";
import { AuthProvider } from "./Auth";
import Sidebar from "./component/Sidebar";
import Home from "./page/Home/Home";
import SupplierRegister from "./page/Suppliers/SupplierRegister";
import SupplierTable from "./page/Suppliers/SupplierTable";
import Suppliers from "./page/Suppliers/Suppliers";
import Products from "./page/Products/Products";
import ProductRegister from "./page/Products/ProductRegister";
import Constant from "./page/Constant/Constant";
import ConstantRegister from "./page/Constant/ConstantRegister";
import Control from "./page/Control/Control";
import Entering from "./page/Entering/Entering";
import Order from "./page/Order/Order";
import OrderConfirm from "./page/Order/OrderConfirm";
import ProductEditor from "./page/Products/ProductEditor";
import SupplierEditor from "./page/Suppliers/SupplierEditor";
import Manufacture from "./page/Manufacture/Manufacture";
import History from "./page/History/History";
import HistoryDetail from "./page/History/HistoryDetail";
import Ordered from "./page/Ordered/Ordered";
import AutomaticOrderingTable from "./page/AutomaticOrdering/AutomaticOrderingTable";
import AutomaticOrdering from "./page/AutomaticOrdering/AutomaticOrdering";
import Login from "./page/Login/Login";
import PriceList from "./page/PriceList/PriceList";
import Temporarily from "./page/Temporarily/Temporarily";
import TemporarilyTable from "./page/Temporarily/TemporarilyTable";
import Reservation from "./page/Reservation/Reservation";
import ReservationTable from "./page/Reservation/ReservationTable";
import OrderAlarm from "./page/OrderAlarm/OrderAlarm";
import Search from "./page/Search/Search";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="*"
              element={
                <>
                  <Sidebar />
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/Search" element={<Search />} />
                    <Route path="/Suppliers" element={<Suppliers />} />
                    <Route
                      path="/SupplierRegister"
                      element={<SupplierRegister />}
                    />
                    <Route
                      path="/SupplierEditor"
                      element={<SupplierEditor />}
                    />
                    <Route path="/SupplierTable" element={<SupplierTable />} />
                    <Route path="/Products" element={<Products />} />
                    <Route
                      path="/ProductRegister"
                      element={<ProductRegister />}
                    />
                    <Route path="/Constant" element={<Constant />} />
                    <Route
                      path="/ConstantRegister"
                      element={<ConstantRegister />}
                    />
                    <Route path="/Control" element={<Control />} />
                    <Route path="/Entering" element={<Entering />} />
                    <Route path="/Order" element={<Order />} />
                    <Route path="/OrderConfirm" element={<OrderConfirm />} />
                    <Route path="/History" element={<History />} />
                    <Route path="/ProductEditor" element={<ProductEditor />} />
                    <Route path="/Manufacture" element={<Manufacture />} />
                    <Route path="/HistoryDetail" element={<HistoryDetail />} />
                    <Route path="/Ordered" element={<Ordered />} />
                    <Route
                      path="/AutomaticOrderingTable"
                      element={<AutomaticOrderingTable />}
                    />
                    <Route
                      path="/AutomaticOrdering"
                      element={<AutomaticOrdering />}
                    />
                    <Route path="/Pricelist" element={<PriceList />} />
                    <Route path="/Temporarily" element={<Temporarily />} />
                    <Route
                      path="/TemporarilyTable"
                      element={<TemporarilyTable />}
                    />
                    <Route path="/Reservation" element={<Reservation />} />
                    <Route
                      path="/ReservationTable"
                      element={<ReservationTable />}
                    />
                    <Route path="/OrderAlarm" element={<OrderAlarm />} />
                  </Routes>
                </>
              }
            />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
